import React from 'react';
import {
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
  MDBBtn,
} from 'mdbreact';

// WHY THIS DIALOG NEEDED A `reason` (owner, 2026-10-20): "There is no model
// associated with this component, although all data is there it's just not
// loaded".
//
// It said that one sentence whatever had happened, and on a 1.39M-element
// export most of the model is never resident, so the commonest case by far was
// an element that EXISTS and had not streamed in yet. Telling someone their
// data is absent when it is merely late is the kind of confident wrong answer
// that costs an afternoon - the owner went looking for a broken exporter
// because of this sentence.
//
// `reason` is optional, so every caller that has not been given one yet keeps
// the old wording rather than showing a blank dialog. The title follows the
// reason: "Not loaded yet" is not a missing model.
const NoMeshModal = props => {
  const reason = props.reason || 'There is no model associated with this component.';
  const notLoaded = !!props.reason;
  return (
    <MDBModal isOpen={props.isOpen} toggle={props.toggle} centered>
      <MDBModalHeader toggle={props.toggle}>{notLoaded ? 'Not loaded yet' : 'No mesh'}</MDBModalHeader>
      <MDBModalBody className="font-size-1">{reason}</MDBModalBody>
      <MDBModalFooter>
        <MDBBtn color="blue darken-2" size="sm" onClick={props.toggle}>
          Ok
        </MDBBtn>
      </MDBModalFooter>
    </MDBModal>
  );
};

export default NoMeshModal;
